module.exports = __webpack_public_path__ + "static/media/digitalTransformation.svg:Zone.7a821669.Identifier";